<div class="proto">
	<h2>Flowmeter assign prototype</h2>
	<p class="muted">
		Irrigation events from the flowmeter, for one planting. Filled drop = this planting.
		Outline = not this planting. Name = claimed by another planting (still selectable).
	</p>

	<label class="planting-pick">
		Planting
		<select [(ngModel)]="current" (ngModelChange)="onPlantingChange()">
			<option *ngFor="let p of plantings; let i = index" [ngValue]="i">{{ p.name }}</option>
		</select>
	</label>

	<div class="modes">
		<button type="button" [class.on]="mode === 'month'" (click)="setMode('month')">Month</button>
		<button type="button" [class.on]="mode === 'week'" (click)="setMode('week')">Week</button>
	</div>

	<div class="nav">
		<button type="button" (click)="prev()" [disabled]="!canGoPrev">
			{{ mode === 'month' ? 'Previous month' : 'Previous week' }}
		</button>
		<strong>{{ title }}</strong>
		<button type="button" (click)="next()" [disabled]="!canGoNext">
			{{ mode === 'month' ? 'Next month' : 'Next week' }}
		</button>
	</div>

	<table *ngIf="mode === 'month'" class="cal">
		<thead>
			<tr>
				<th *ngFor="let d of weekdays">{{ d }}</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let week of weeks">
				<td *ngFor="let cell of week"
					[class.out]="!cell.inMonth"
					[class.event]="cell.hasEvent"
					[class.mine]="cell.mine"
					(click)="clickDay(cell)">
					<span *ngIf="cell.inMonth" class="num">{{ cell.day }}</span>
					<span *ngIf="cell.hasEvent" class="drop"
						[style.background]="cell.mine ? planting.color : 'transparent'"
						[style.border-color]="planting.color"></span>
					<span class="claim" *ngIf="cell.claimedBy.length">
						{{ cell.claimedBy.join(', ') }}
					</span>
				</td>
			</tr>
		</tbody>
	</table>

	<ng-container *ngIf="mode === 'week'">
		<table class="cal week-cal">
			<thead>
				<tr>
					<th *ngFor="let d of weekdays">{{ d }}</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td *ngFor="let cell of weekCells"
						[class.event]="cell.hasEvent"
						[class.mine]="cell.mine"
						(click)="clickDay(cell)">
						<span class="num">{{ cell.day }}</span>
						<span *ngIf="cell.hasEvent" class="drop"
							[style.background]="cell.mine ? planting.color : 'transparent'"
							[style.border-color]="planting.color"></span>
						<span class="claim" *ngIf="cell.claimedBy.length">
							{{ cell.claimedBy.join(', ') }}
						</span>
					</td>
				</tr>
			</tbody>
		</table>

		<table class="events">
			<thead>
				<tr>
					<th>Date</th>
					<th>Gallons</th>
					<th>Minutes</th>
					<th>App. rate (in/hr)</th>
					<th>Applied (in.)</th>
					<th>This planting</th>
					<th>Also claimed by</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngIf="!weekRows.length">
					<td colspan="7" class="muted">No irrigation events this week.</td>
				</tr>
				<tr *ngFor="let row of weekRows">
					<td>{{ row.dateLabel }}</td>
					<td>{{ row.gallons }}</td>
					<td>{{ row.minutes }}</td>
					<td>{{ row.appRate }}</td>
					<td>{{ row.applied }}</td>
					<td>{{ row.mine ? 'Yes' : 'No' }}</td>
					<td>{{ row.claimedBy.join(', ') || '—' }}</td>
				</tr>
			</tbody>
		</table>
	</ng-container>

	<button type="button" (click)="save()">Save</button>
	<p class="status" *ngIf="status">{{ status }}</p>
</div>
